import React from 'react';
import { Link } from 'react-router-dom';
import './Partner.css';

function Partner() {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! Your information has been submitted successfully. We will get in touch with you soon.");
  };

  return (
    <div className="partnership-page-wrapper">
      {/* Partnership Hero Banner Section */}
      <div className="partnership-hero">
        <div className="partnership-hero-overlay"></div>
        <div className="partnership-hero-content">
          <h2>Partnership</h2>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="partnership-content-section">
        <div className="partnership-breadcrumb-container">
          <Link to="/" onClick={() => window.scrollTo(0, 0)} className="breadcrumb-home" style={{ textDecoration: 'none' }}>Home</Link>
          <span className="breadcrumb-separator"> / </span>
          <span className="breadcrumb-current">Become a Merchant</span>
        </div>

        {/* Content detail layout */}
        <div className="partnership-main-grid">
          {/* Left Column */}
          <div className="partnership-left-text-section">
            <h1 className="partnership-headline">
              Become a <span className="black-accent">Merchant</span>
            </h1>

            <div className="partnership-illustration-container">
              <img
                src="/Image/earnmoney.png"
                alt="Become a Partner Illustration"
                className="partnership-main-illustration"
              />
            </div>

            <p className="partnership-left-subtext">
              Join ZustGo and turn your kitchen into a powerful online business. Get more orders, attract local customers, and boost your revenue effortlessly
            </p>
          </div>

          {/* Right Column: Registration Card */}
          <div className="partnership-right-visual-section">
            <div className="partnership-form-card">
              <h2 className="partnership-form-title">
                List your shop in <span className="black-accent">ZustGo</span>
              </h2>
              <p className="partnership-form-subtitle">
                Please provide your info, we will get in touch with you.
              </p>

              <form onSubmit={handleSubmit} className="partnership-registration-form">
                <div className="form-group-relative">
                  <input type="text" placeholder="Name" required className="form-input-premium" />
                  <span className="required-star">*</span>
                </div>

                <div className="form-group-relative">
                  <input type="email" placeholder="Email Address" required className="form-input-premium" />
                  <span className="required-star">*</span>
                </div>

                <div className="form-phone-row">
                  <div className="phone-code-col">
                    <input type="text" placeholder="Ex: 91" required className="form-input-premium code-input" />
                  </div>
                  <div className="phone-num-col form-group-relative">
                    <input type="tel" placeholder="Phone Number" required className="form-input-premium" />
                    <span className="required-star">*</span>
                  </div>
                </div>

                <div className="form-group-relative">
                  <input type="text" placeholder="Location Name" className="form-input-premium" />
                </div>

                <div className="form-group-relative">
                  <input type="text" placeholder="Shop Name" className="form-input-premium" />
                </div>

                <div className="form-group-relative">
                  <textarea placeholder="Address" className="form-textarea-premium" rows="3"></textarea>
                </div>

                <button type="submit" className="partnership-submit-btn">Submit</button>
              </form>

              <div className="form-privacy-note">
                <span className="shield-icon">
                  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 0L0 4V10C0 15.55 3.84 20 9 20C14.16 20 18 15.55 18 10V4L9 0ZM7.2 14.5L3 10.3L4.4 8.9L7.2 11.7L13.6 5.3L15 6.7L7.2 14.5Z" fill="#111111" />
                  </svg>
                </span>
                <p>We'll never share your email & phone number with anyone else.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partner;